export default __webpack_public_path__ + "static/media/bibox.ac98d144.png";